export * from './helpers'
export * from './validateRegex'

export const getAccessRights = (user, code, action) => {
  if (!user?.uloga?.pravaPristupa?.[code] || !user?.uloga?.pravaPristupa?.[code]?.find(e => e === action)) return true
  else return false
}
